import { useState, useRef, useEffect } from 'react';

const LazyImage = ({ src, alt, className, style, placeholder, width, height, ...props }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isInView, setIsInView] = useState(false);
    const imgRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsInView(true);
                        observer.disconnect();
                    }
                });
            },
            {
                rootMargin: '50px',
                threshold: 0.01
            }
        );

        const currentImg = imgRef.current;
        if (currentImg) {
            observer.observe(currentImg);
        }

        return () => {
            if (currentImg) {
                observer.unobserve(currentImg);
            }
        };
    }, []);

    return (
        <div
            ref={imgRef}
            className={className}
            style={{
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: placeholder || '#f0f0f0',
                ...style
            }}
        >
            {isInView && (
                <img
                    src={src}
                    alt={alt || ''}
                    width={width}
                    height={height}
                    onLoad={() => setIsLoaded(true)}
                    style={{
                        opacity: isLoaded ? 1 : 0,
                        transition: 'opacity 0.3s ease-in-out',
                        width: width ? undefined : '100%',
                        height: height ? undefined : '100%',
                        objectFit: 'cover',
                        ...props.style
                    }}
                    loading="lazy"
                    decoding="async"
                    {...props}
                />
            )}
            {!isLoaded && isInView && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                        backgroundSize: '200% 100%',
                        animation: 'shimmer 1.5s infinite',
                    }}
                />
            )}
        </div>
    );
};

export default LazyImage;

